import React, {useContext} from 'react';
import {useNavigate,} from 'react-router';
import Footer from '../../common/footer/footer';
import "./searchPage.css"
import {Context} from "../../context/ContextData"
import { FaSearch } from "react-icons/fa";

const SearchPage = () => {

const {setSearch,Search} = useContext(Context);

    // const [search, setSearch] = useState("")
    const navigate = useNavigate();


    const userSearch = () => {
        if(Search){
            navigate(`/response/${Search}`)
            setSearch("")
        }

    }
    return (

        <div className="search-bg position-relative">
            <div className="row parent-row">
                    <div className="d-flex flex-column justify-content-center align-items-center col-11 col-sm-9 col-md-8 col-lg-6 col-xl-4  gap-4 search-user" style={{zIndex:"100"}}>
                        {/* <div className="search-logo "></div> */}
                        <img className='search-logo' src="/images/logo.png" alt=""/>
                        <h6 className="h-6 text-white px-2">به مرکز پاسخگوی هوشمند سازمان امور مالیاتی کشور خوش آمدید</h6>
                        <form className='form-size position-relative' onSubmit={userSearch}>
                            <input type="text"
                                   className="form-control user-search px-2  w-100" id="search"
                                   aria-describedby="search" aria-label="چطور میتوانیم به شما کمک کنیم؟"
                                   placeholder="چطور میتوانیم به شما کمک کنیم؟"
                                   onChange={e => setSearch(e.target.value)}
                                   value={Search}/>
                                  <button type="submit" onSubmit={userSearch} className="search-btn" >
                                    <FaSearch style={{position:"absolute" , top:"8px", left:"5px", fontSize:"25px", cursor:"pointer"}}/>
                                  </button>                
                        </form>
                    
                        {/*soroush remove*/}
                        {/*<Faq/>*/}
                    </div>


            </div>
            <Footer/>
        </div>
    );
}

export default SearchPage;